// export default server
import router from '@/router'
import { Message, Loading } from 'element-ui';
import axios from "axios";
// import qs from "qs";

// 不能设置为 true
// axios.defaults.withCredentials = false;

axios.defaults.timeout = 100000; //响应时间
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8"; //配置请求头
// axios.defaults.headers.post["Cache-Control"] =
//   "no-cache"; //配置请求头
// axios.defaults.headers.get["Content-Type"] =
//   "application/x-www-form-urlencoded;charset=UTF-8"; //配置请求头
// axios.defaults.headers.get["Cache-Control"] =
//   "no-cache"; //配置请求头
axios.defaults.baseURL = '';   //配置接口地址
axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? "https://www.rmbsilkroad.cn/api/"
    : "/api"; //配置接口地址
let baseUrl = '';
switch (process.env.NODE_ENV) {
  case 'development':
    baseUrl = "https://www.rmbsilkroad.cn/api/"  //开发环境url
    break
  case 'production':
    // baseUrl: "https://www.rmbsilkroad.cn/api",
    baseUrl = "https://www.rmbsilkroad.cn/api/"   //生产环境url
    // baseUrl = "https://api.rmbsilkroad.cn/api/"   //生产环境url
    break
}

// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'http://192.168.250.38:8080/amc' : '/api';  //配置接口地址
//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  (config) => {
    // let authorization = window.localStorage.getItem("authorization") || '';
    let token = window.localStorage.getItem("token");
    if (token) {
      //将token放到请求头发送给服务器,将tokenkey放在请求头中
      config.headers.Authorization = token;
    }
    //在发送请求之前做某件事
    // if(config.method  === 'post'){
    //     config.data = qs.stringify(config.data);
    // }
    return config;
  },
  (error) => {
    console.log("请求超时!");
    return Promise.reject(error);
  }
);

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  (response) => {
    //对响应数据做些事
    /*if(!res.data.success){
        return Promise.resolve(res);
    }
    return res;*/
    const res = response;
    if (res.status === 200) {
      switch (res.data.code) {
        case 200:
          // 返回 400 清除token信息并跳转到登录页面
          return res.data;
          break;
        case 400:
          // 返回 400 清除token信息并跳转到登录页面
          Message.error({ message: res.data.msg });
          break;
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          // store.commit(types.LOGOUT);
          Message.warning({ message: "登陆失效，请重新登陆" });
          //跳转到登录
          router.push("/login");
          break;
        case 500:
          // 返回 500 清除token信息并跳转到登录页面
          Message.error({ message: "服务端出错" });
          break;
      }
      return res.data;
    }
    // else if (res.status === 200) {
    //   return res.data;
    // } 
  },
  (error) => {
    console.log(error);
    // const status = error.response.status;
    const err = error.response;
    if (error.response) {
      switch (error.response.status) {
        case 400:
          // 返回 400 清除token信息并跳转到登录页面
          Message.error({ message: err.msg });
          break;
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          // store.commit(types.LOGOUT);
          Message.error({ message: "登陆失效，请重新登陆" });
          router.push("/login");
          break;
        case 500:
          // 返回 500 清除token信息并跳转到登录页面
          Message.error({ message: "服务端出错" });
          break;
      }
    }
    return Promise.reject(err); // 返回接口返回的错误信息
  }
);

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
//返回一个Promise(发送get请求)
export function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: param })
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  fetchPost,
  fetchGet,
  baseUrl
};
